import type React from "react";
import { Dialog } from "../ui/dialog";
import { useHandleNavigate } from "../../utils/utils";

type AppProps = {
	children: React.ReactNode;
	navigatePath: string;
};
export const Modal: React.FunctionComponent<AppProps> = ({
	navigatePath,
	children,
}) => {
	const {handleNavigate, open} = useHandleNavigate(navigatePath);

	return (
		<Dialog open={open} onOpenChange={handleNavigate}>
			{children}
		</Dialog>
	);
};
